module.exports = __webpack_public_path__ + "coat_of_arms.ada90e288a9fa447304fc90a74b337db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/coat_of_arms.png
// module id = 466
// module chunks = 0